import { useEffect, useState } from "react";
import { useGetCatalogConstruction } from "./callApis/callApiCatalogTypeConstruction";
import { useGetCatalogBusinessType } from "./callApis/callApiCatalogBusinessType";
import { useGetCatalog } from "./callApis/callApiCatalog";
export var useCatalogues = function (propertyTypeId) {
    var _a = useState(false), trigger = _a[0], setTrigger = _a[1];
    var _b = useState([]), businessType = _b[0], setBusinessType = _b[1];
    var _c = useState([]), businessShift = _c[0], setBusinessShift = _c[1];
    var _d = useState([]), typeConstruction = _d[0], setTypeConstruction = _d[1];
    useEffect(function () {
        setTrigger(true);
    }, []);
    var _e = useGetCatalogConstruction(trigger), responseCatalogConstruction = _e.responseCatalogConstruction, loadingCatalogConstruction = _e.loadingCatalogConstruction, errorCatalogConstruction = _e.errorCatalogConstruction;
    var _f = useGetCatalogBusinessType(trigger), responseCatalogBusiness = _f.responseCatalogBusiness, loadingCatalogBusiness = _f.loadingCatalogBusiness, errorCatalogBusiness = _f.errorCatalogBusiness;
    var _g = useGetCatalog(trigger, propertyTypeId), responseCatalogues = _g.responseCatalogues, loadingCatalogues = _g.loadingCatalogues, errorCatalogues = _g.errorCatalogues;
    //"5f11800b-eedf-4686-8537-94cd052d436e"
    //"0a7d1a0a-27cf-4981-9bbc-3320de1f51e7"
    useEffect(function () {
        if (responseCatalogConstruction === null || responseCatalogConstruction === void 0 ? void 0 : responseCatalogConstruction.length) {
            var constructionTypes = responseCatalogConstruction.map(function (item) { return ({
                id: item.id,
                value: item.id,
                name: item.description,
            }); });
            setTypeConstruction(constructionTypes);
        }
    }, [responseCatalogConstruction]);
    useEffect(function () {
        if (responseCatalogBusiness === null || responseCatalogBusiness === void 0 ? void 0 : responseCatalogBusiness.length) {
            var businessTypes = responseCatalogBusiness.map(function (item) { return ({
                id: item.id,
                value: item.id,
                name: item.description,
            }); });
            setBusinessType(businessTypes);
        }
    }, [responseCatalogBusiness]);
    useEffect(function () {
        if (responseCatalogues === null || responseCatalogues === void 0 ? void 0 : responseCatalogues.length) {
            var businessShift_1 = responseCatalogues.map(function (item) { return ({
                id: item.id,
                value: item.id,
                name: item.description,
            }); });
            setBusinessShift(businessShift_1);
        }
    }, [responseCatalogues]);
    return {
        errorCatalogues: errorCatalogConstruction || errorCatalogBusiness || errorCatalogues,
        loadingCatalogues: loadingCatalogConstruction || loadingCatalogBusiness || loadingCatalogues,
        businessType: businessType,
        typeConstruction: typeConstruction,
        businessShift: businessShift,
    };
};
